import { List } from "immutable";

export default function getDefaultTab(session) {
  var abilities = session.get("abilities") || List();
  if (abilities.includes("enter cash contests")) {
    return "upcoming";
  } else if (abilities.includes("enter qualifier contests")) {
    return "qualify";
  } else {
    return "points";
  }
}
